import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { TvoComponent } from './tvo.component';

const defaultRouteGuards = [RoleEnum.TVO.toString()];
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: TvoComponent,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'pedidos',
        loadChildren: async () => (await import('./order/order.module')).OrderModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'triagem',
        loadChildren: async () => (await import('./screening/screening.module')).ScreeningModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'acessos',
        loadChildren: async () =>
          (await import('../core/access-control/access-control.module')).AccessControlModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'relatorio',
        loadChildren: async () => (await import('./reports/reports.module')).ReportsModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'erros',
        loadChildren: async () =>
          (await import('./errors-manager/errors-manager.module')).ErrorsManagerModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'transportadoras',
        loadChildren: async () => (await import('../tvf/carriers/carriers.module')).CarriersModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'varejistas',
        loadChildren: async () => (await import('../tvf/retailers/retailers.module')).RetailersModule,
        data: { num: 10, roles: defaultRouteGuards },
      },
      {
        path: 'lojas',
        loadChildren: async () => (await import('../tvf/stores/stores.module')).StoreModule,
        data: { num: 10, roles: defaultRouteGuards },
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TvoRoutingModule {}
